import { GroupBase, StylesConfig } from "react-select";
import { SearchItem } from "./storeSearchInput.types";
import { getDamPath } from "@utils/configuration/aem";

export const MAX_LOCALITIES = 3;
export const MAX_STORES = 2;

export const INPUT_STYLES: StylesConfig<SearchItem, false, GroupBase<SearchItem>> = {
    control: (provided) => ({
        ...provided,
        borderBottomRightRadius: 0,
        borderTopRightRadius: 0,
    }),
    menuList: (provided) => ({
        ...provided,
        overflow: "hidden",
        padding: 0
    }),
};

export const HIGHLIGHT_PREFIX = "<span>";
export const HIGHLIGHT_POSTFIX = "</span>";

export const HUBO_ICON_URL = `${getDamPath()}/icons/maps/icon.png`
